import { SkaldAuraProvider } from '@skaldaura/devkit'
import Home from 'home'
import { useEffect, useState } from 'react'
import './styles/flex.scss'
import './styles/globals.scss'
export default function App() {
   const counterDefault = 300
   const [counter, setCounter] = useState(counterDefault)
   useEffect(() => {
      const timer: any = counter > 0 && setInterval(() => setCounter(counter - 1), 1000)
      return () => clearInterval(timer)
   }, [counter])
   return (
      <SkaldAuraProvider devname='Aptar Neubourg' env='prod'>
         <Home />
      </SkaldAuraProvider>
   )
}
